import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const BlogCard = ({ post }) => {
  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'd MMMM yyyy', { locale: fr });
    } catch {
      return dateString;
    }
  };

  return (
    <Link 
      to={`/blog/${post.slug}`} 
      className="block blog-card bg-white rounded-2xl overflow-hidden border border-stone-100"
      data-testid={`blog-card-${post.slug}`}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={post.image_url}
          alt={post.title}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-emerald-600 text-white text-xs font-medium px-3 py-1 rounded-full">
            {post.category}
          </span>
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 text-stone-500 text-xs mb-3">
          <Calendar className="w-3.5 h-3.5" />
          {formatDate(post.created_at)}
        </div>
        <h3 className="font-heading font-semibold text-stone-900 text-lg mb-2 line-clamp-2">
          {post.title}
        </h3>
        <p className="text-stone-600 text-sm line-clamp-2 mb-4">
          {post.excerpt}
        </p>
        <span className="inline-flex items-center gap-2 text-emerald-600 font-medium text-sm group">
          Lire la suite
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
};

export default BlogCard;
